import { styled } from "@mui/material";

export const ContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
}));
